import { goSolidApi } from "@/composables/useGoSolidApi";
import type { AllDocumentsResponse } from "./documentTypes";

export async function fetchAllDocuments(
  companyId: number
): Promise<AllDocumentsResponse> {
  const response = await goSolidApi.get<AllDocumentsResponse>(
    `/api/company/${companyId}/documents`
  );
  return response.data;
}

export async function archiveUpload(
  companyId: number,
  uploadId: number
): Promise<void> {
  await goSolidApi.delete(`/api/company/${companyId}/uploads/${uploadId}`);
}
